<template>
  <!-- Outer fixed canvas -->
  <div :style="{ width: `${width}px`, height: `${height}px`, background: '#EAEAEA' }" class="relative overflow-hidden" ref="canvasRoot">
    <!-- Inner rounded container with margin 62px -->
    <div class="absolute inset-0" :style="{ padding: '62px' }">
      <div class="w-full h-full bg-white rounded-[56px] overflow-hidden flex" :style="{ boxShadow: '0 12px 40px rgba(0,0,0,0.08), 0 2px 10px rgba(0,0,0,0.05)' }">
        <!-- Left column -->
        <div class="h-full flex flex-col justify-between" :style="{ width: '760px', paddingRight: '48px', paddingBottom: '48px', paddingLeft: '66px', paddingTop: '69px' }">
          <div>
            <h1 class="font-extrabold" :style="{ fontFamily: `'Nunito Sans', sans-serif`, fontWeight: 800, fontSize: '77px', color: '#FF2E2E', lineHeight: '0.95',marginLeft: '-5px', marginTop: '-10px'  }">{{ titleNbsp }}</h1>
            <p class="mt-2 font-semibold" :style="{ fontFamily: `'Nunito Sans', sans-serif`, fontWeight: 600, fontSize: '31px', color: '#FF2E2E', display: 'flex', alignItems: 'flex-start', gap: '10px' }">
              <span aria-hidden="true" :style="{ lineHeight: 0, marginLeft: '-10px' }">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" :style="{ width: '36px', height: '36px', stroke: '#FF2E2E' }">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
                </svg>
              </span>
              <span>{{ address }}</span>
            </p>
            <p class="mt-4" :style="{ fontFamily: 'Inter, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif', fontWeight: 400, fontSize: '14px', color: '#9CA3AF' }">{{ descriptionNbsp }}</p>
          </div>
          <div class="mt-6" :style="{ fontFamily: `'Nunito Sans', sans-serif`, fontSize: '18px', color: '#FF2E2E', fontWeight: 700 }">
            więcej na <span :style="{ textDecoration: 'underline' }">www.muala.app</span>
          </div>
        </div>

        <!-- Right column -->
        <div class="flex-1 h-full flex items-center justify-center px-8" :style="{ borderLeft: '9px dotted #EAEAEA' }">
          <div class="grid grid-cols-1 gap-12 w-full max-w-3xl">
            <!-- Box 1: external average rating -->
            <div class="p-4 text-center">
              <div class="text-7xl" :style="{ color:'#1D4ED8', fontFamily: 'Inter, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif', fontWeight: 700 }">{{ externalAvgRatingDisplay }}</div>
              <div class="flex justify-center mb-2" :style="{ fontSize: '24px', lineHeight: 1 }">
                <div class="relative" style="display:inline-block">
                  <div style="color:#E5E7EB">★★★★★</div>
                  <div class="absolute inset-0 overflow-hidden" :style="{ width: externalStarPercent }">
                    <div style="color:#F59E0B">★★★★★</div>
                  </div>
                </div>
              </div>
              <div class="text-sm text-gray-400" :style="{ fontFamily: 'Inter, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif' }">średnia z ostatnich 50 ocen</div>
            </div>

            <!-- Box 2: trend -->
            <div class="text-center">
              <div class="flex items-center justify-center gap-2">
                <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="h-8 w-8">
                  <circle cx="9.41479" cy="9.85059" r="9.23901" :fill="trendColor"/>
                  <g v-if="isGreenUp">
                    <path d="M13.3753 10.4543C13.518 10.5971 13.5982 10.7907 13.5982 10.9926C13.5982 11.1945 13.518 11.3882 13.3753 11.531L9.94882 14.9574C9.80604 15.1002 9.6124 15.1804 9.41049 15.1804C9.20859 15.1804 9.01495 15.1002 8.87216 14.9574L5.4457 11.531C5.307 11.3874 5.23025 11.195 5.232 10.9954C5.23374 10.7957 5.31382 10.6048 5.455 10.4636C5.59618 10.3224 5.78716 10.2423 5.98681 10.2406C6.18645 10.2389 6.37879 10.3156 6.52239 10.4543L8.64907 12.5155L8.64907 5.28189C8.64907 5.07994 8.72929 4.88627 8.87208 4.74348C9.01487 4.60069 9.20855 4.52047 9.41049 4.52047C9.61244 4.52047 9.80611 4.60069 9.9489 4.74348C10.0917 4.88627 10.1719 5.07994 10.1719 5.28189L10.1719 12.5155L12.2986 10.4543C12.4414 10.3116 12.635 10.2314 12.8369 10.2314C13.0388 10.2314 13.2325 10.3116 13.3753 10.4543Z" fill="#F9FAFB"/>
                  </g>
                  <g v-else>
                    <path transform="rotate(180 9.41479 9.85059)" d="M13.3753 10.4543C13.518 10.5971 13.5982 10.7907 13.5982 10.9926C13.5982 11.1945 13.518 11.3882 13.3753 11.531L9.94882 14.9574C9.80604 15.1002 9.6124 15.1804 9.41049 15.1804C9.20859 15.1804 9.01495 15.1002 8.87216 14.9574L5.4457 11.531C5.307 11.3874 5.23025 11.195 5.232 10.9954C5.23374 10.7957 5.31382 10.6048 5.455 10.4636C5.59618 10.3224 5.78716 10.2423 5.98681 10.2406C6.18645 10.2389 6.37879 10.3156 6.52239 10.4543L8.64907 12.5155L8.64907 5.28189C8.64907 5.07994 8.72929 4.88627 8.87208 4.74348C9.01487 4.60069 9.20855 4.52047 9.41049 4.52047C9.61244 4.52047 9.80611 4.60069 9.9489 4.74348C10.0917 4.88627 10.1719 5.07994 10.1719 5.28189L10.1719 12.5155L12.2986 10.4543C12.4414 10.3116 12.635 10.2314 12.8369 10.2314C13.0388 10.2314 13.2325 10.3116 13.3753 10.4543Z" fill="#F9FAFB"/>
                  </g>
                </svg>
                <div class="text-2xl" :style="{ color: trendColor, fontFamily: 'Inter, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif', fontWeight: 700 }">{{ diffDisplay }}</div>
              </div>
            </div>

            <!-- Box 3: Google rating -->
            <div class="text-center p-4">
              <div class="flex items-center justify-center gap-2">
                <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" class="h-7 w-7">
                  <path d="M17.2628 7.94956H16.6252V7.91671H9.50016V11.0834H13.9743C13.3215 12.9268 11.5676 14.25 9.50016 14.25C6.87698 14.25 4.75016 12.1232 4.75016 9.50004C4.75016 6.87685 6.87698 4.75004 9.50016 4.75004C10.711 4.75004 11.8126 5.20683 12.6514 5.95298L14.8906 3.71375C13.4767 2.39602 11.5854 1.58337 9.50016 1.58337C5.12818 1.58337 1.5835 5.12806 1.5835 9.50004C1.5835 13.872 5.12818 17.4167 9.50016 17.4167C13.8721 17.4167 17.4168 13.872 17.4168 9.50004C17.4168 8.96923 17.3622 8.45108 17.2628 7.94956Z" fill="#FFC107"/>
                  <path d="M2.49609 5.81523L5.09711 7.72275C5.80091 5.98029 7.50536 4.75004 9.49997 4.75004C10.7108 4.75004 11.8124 5.20683 12.6512 5.95298L14.8904 3.71375C13.4765 2.39602 11.5852 1.58337 9.49997 1.58337C6.45918 1.58337 3.82214 3.3001 2.49609 5.81523Z" fill="#FF3D00"/>
                  <path d="M9.49996 17.4167C11.5448 17.4167 13.4029 16.6341 14.8077 15.3615L12.3575 13.2882C11.5361 13.9132 10.5321 14.2511 9.49996 14.25C7.44084 14.25 5.69244 12.937 5.03377 11.1047L2.45215 13.0938C3.76236 15.6576 6.42315 17.4167 9.49996 17.4167Z" fill="#4CAF50"/>
                  <path d="M17.2627 7.94948H16.625V7.91663H9.5V11.0833H13.9741C13.6619 11.9606 13.0995 12.7273 12.3563 13.2885L12.3575 13.2877L14.8077 15.3611C14.6344 15.5186 17.4167 13.4583 17.4167 9.49996C17.4167 8.96915 17.362 8.451 17.2627 7.94948Z" fill="#1976D2"/>
                </svg>
                <div class="text-3xl text-gray-700" :style="{ fontFamily: 'Inter, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif', fontWeight: 700 }">{{ googleRatingDisplay }}</div>
              </div>
              <div class="text-sm text-gray-400" v-if="hasGoogleCount" :style="{ fontFamily: 'Inter, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif' }">
                <div>średnia ze wszystkich</div>
                <div>{{ googleCount }} ocen</div>
              </div>
              <div class="text-sm text-gray-400" v-else :style="{ fontFamily: 'Inter, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif' }">średnia ze wszystkich ocen</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'

const props = defineProps({
  title: { type: String, default: '' },
  city: { type: String, default: '' },
  address: { type: String, default: '' },
  description: { type: String, default: '' },
  ratingValue: { type: [String, Number], default: '' },
  reviewCount: { type: [String, Number], default: '' },
  authorsAvatars: { type: Array, default: () => [] },
  width: { type: Number, default: 1200 },
  height: { type: Number, default: 630 },
  footerText: { type: String, default: 'Open Graph Preview' },
  // extended metrics (optional)
  externalAvgRating: { type: [String, Number], default: undefined },
  externalCount: { type: [String, Number], default: undefined },
  googleRating: { type: [String, Number], default: undefined },
  googleCount: { type: [String, Number], default: undefined },
  trend: { type: [String, Number], default: undefined },
})

const canvasRoot = ref(null)
const filledStars = computed(() => {
  const v = Number(props.ratingValue)
  if (!isFinite(v)) return 0
  return Math.max(0, Math.min(5, Math.round(v)))
})

const titleNbsp = computed(() => {
  if (!props.title) return ''
  let s = props.title
  // Zamień spacje po jednoliterowych wyrazach (np. U, W, Z, O, I, A) na niełamaną
  s = s.replace(/\b([UuWwZzOoIiAa])\s+(?=\S)/g, (_, p1) => `${p1}\u00A0`)
  return s
})

const descriptionNbsp = computed(() => {
  if (!props.description) return ''
  return props.description.replace(/\b([UuWwZzOoIiAa])\s+(?=\S)/g, (_, p1) => `${p1}\u00A0`)
})

const externalFilledStars = computed(() => {
  const v = Number(props.externalAvgRating ?? props.ratingValue)
  if (!isFinite(v)) return 0
  return Math.max(0, Math.min(5, Math.round(v)))
})

const externalAvgRatingDisplay = computed(() => {
  const v = props.externalAvgRating ?? props.ratingValue
  return v ? Number(v).toFixed(1) : '-'
})

const googleRatingDisplay = computed(() => {
  const v = props.googleRating ?? props.ratingValue
  return v ? Number(v).toFixed(1) : '-'
})

const trendDisplay = computed(() => {
  if (props.trend === undefined || props.trend === null || props.trend === '') return '0.0'
  const num = Number(props.trend)
  if (!isFinite(num)) return '0.0'
  return (num > 0 ? `+${num}` : `${num}`)
})

const hasExternalCount = computed(() => props.externalCount !== undefined && props.externalCount !== null && props.externalCount !== '')
const hasGoogleCount = computed(() => props.googleCount !== undefined && props.googleCount !== null && props.googleCount !== '')

// Diff between googleRating and externalAvgRating
const diff = computed(() => {
  const gRaw = Number(props.googleRating ?? props.ratingValue)
  const eRaw = Number(props.externalAvgRating ?? props.ratingValue)
  if (!isFinite(gRaw) || !isFinite(eRaw)) return 0
  const round1 = (x) => Math.round(x * 10) / 10
  const g = round1(gRaw)
  const e = round1(eRaw)
  return round1(g - e)
})

const diffDisplay = computed(() => {
  const d = -diff.value
  const formatted = isFinite(d) ? d.toFixed(1) : '0.0'
  return d > 0 ? `+${formatted}` : `${formatted}`
})

const trendColor = computed(() => {
  const d = diff.value
  // dodatni = czerwony, ujemny = zielony
  if (d > 0) return '#DC2626'
  if (d < 0) return '#16A34A'
  return '#6B7280'
})

// Percent fill for 5-star strip (supports halves via CSS clipping)
const percentFromRating = (r) => {
  const v = Number(r)
  if (!isFinite(v)) return '0%'
  const clamped = Math.max(0, Math.min(5, v))
  return `${(clamped / 5) * 100}%`
}

const externalStarPercent = computed(() => percentFromRating(props.externalAvgRating ?? props.ratingValue))

const isGreenUp = computed(() => diff.value < 0)
</script>

<style scoped>
/* no extra styles */
</style>


